export enum FeatureName {
  MAINTENANCE = 'maintenance',
  LAUNCH_POPUP = 'launch-popup',
  CAMPAIGN_HOMEPAGE_BANNER = 'campaign-homepage-banner',
  CAMPAIGN_COLLECTIBLES_BANNER = 'campaign-collectibles-banner',
  CAMPAIGN_BROWSER = 'campaign-browser',
  SMART_WEARABLES_FTU = 'smart-wearables-ftu',
  CHAIN_SELECTOR = 'chain-selector',
  CROSS_CHAIN_LANDS = 'cross-chain-lands',
  OFFCHAIN_BIDS = 'offchain-bids',
  OFFCHAIN_PUBLIC_NFT_ORDERS = 'offchain-public-nft-orders',
  OFFCHAIN_PUBLIC_ITEM_ORDERS = 'offchain-public-item-orders',
  NAVBAR_UI2 = 'navbar-ui2',
  MAGIC_AUTO_SIGN = 'magic-auto-sign',
  CREDITS = 'credits',
  CREDITS_SECONDARY_SALES = 'credits-secondary-sales',
  USER_WALLETS = 'alfa-marketplace-credits',
  UNITY_WEARABLE_PREVIEW = 'unity-wearable-preview',
  SOCIAL_EMOTES = 'social-emotes',
  NAMES_WITH_CREDITS = 'names-with-credits'
}
